export var AlignItemsProp;
(function (AlignItemsProp) {
    AlignItemsProp["normal"] = "normal";
    AlignItemsProp["stretch"] = "stretch";
    AlignItemsProp["start"] = "flex-start";
    AlignItemsProp["center"] = "center";
    AlignItemsProp["end"] = "flex-end";
    AlignItemsProp["baseline"] = "baseline";
})(AlignItemsProp || (AlignItemsProp = {}));
